<div class="paginator">
  @if (sizeOptions().length > 1) {
    <div class="paginator-size">
      <span>{{ 'SHARED.PAGINATOR.ITEMS_PER_PAGE' | transloco }}</span>
      <ui-dropdown
        class="paginator-size-dropdown"
        [options]="sizeOptions()"
        [value]="page().size"
        [disabled]="disabled()"
        [direction]="'up'"
        (valueChange)="onPageSize($event)"
      />
    </div>
  }

  <span class="paginator-range" data-testid="paginator-range">
    {{ 'SHARED.PAGINATOR.RANGE' | transloco: rangeParams() }}
  </span>

  <div class="paginator-actions">
    <button
      type="button"
      class="paginator-button"
      [disabled]="disabled() || range().isFirst"
      [attr.aria-label]="'SHARED.PAGINATOR.FIRST' | transloco"
      (click)="onFirst()"
    >
      <ui-inline-svg name="chevron-first"></ui-inline-svg>
    </button>

    <button
      type="button"
      class="paginator-button"
      [disabled]="disabled() || range().isFirst"
      [attr.aria-label]="'SHARED.PAGINATOR.PREVIOUS' | transloco"
      (click)="onPrevious()"
    >
      <ui-inline-svg name="chevron-left"></ui-inline-svg>
    </button>

    <button
      type="button"
      class="paginator-button"
      [disabled]="disabled() || range().isLast"
      [attr.aria-label]="'SHARED.PAGINATOR.NEXT' | transloco"
      (click)="onNext()"
    >
      <ui-inline-svg name="chevron-right"></ui-inline-svg>
    </button>

    <button
      type="button"
      class="paginator-button"
      [disabled]="disabled() || range().isLast"
      [attr.aria-label]="'SHARED.PAGINATOR.LAST' | transloco"
      (click)="onLast()"
    >
      <ui-inline-svg name="chevron-last"></ui-inline-svg>
    </button>
  </div>
</div>
